import { createSlice } from '@reduxjs/toolkit';
import { IHomeFilter } from '../homeFilter';

export interface IPopupFilter extends IHomeFilter {
  isPopupOpen: boolean;
  activeSlot: any;
  isAccessoriesPage: boolean;
  isFramePage: boolean;
}
const initialState: IPopupFilter = {
  globalFilters: [],
  filters: {},
  filtersSelectionOrder: [],
  isPopupOpen: false,
  activeSlot: null,
  isAccessoriesPage: false,
  isFramePage: false,
};

export const popupFilters = createSlice({
  name: 'popupFilter',
  initialState,
  reducers: {
    setGlobalFilters: (state, action) => {
      state.globalFilters = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setFiltersSelectionOrder: (state, action) => {
      state.filtersSelectionOrder = action.payload;
    },
    setActiveSlot: (state, action) => {
      state.activeSlot = action.payload;
    },
    setPopupState: (state, action) => {
      state.isPopupOpen = action.payload;
    },
    setAccessoriesPage: (state, action) => {
      state.isAccessoriesPage = action.payload;
    },
    setFramePage: (state, action) => {
      state.isFramePage = action.payload;
    },
  },
});
export const {
  setGlobalFilters,
  setFilters,
  setFiltersSelectionOrder,
  setActiveSlot,
  setPopupState,
  setAccessoriesPage,
  setFramePage,
} = popupFilters.actions;
export default popupFilters.reducer;
